import cn from "classnames";
import React from "react";
import { assertNever, formatPrice } from "../../util";
const PriceWithCents = ({ id, className, amount, prefix = "$", typography = "typography-main", ...rest }) => {
    const [dollars, cents] = formatPrice(amount).split(".");
    const centStyles = (t) => {
        switch (t) {
            case "typography-h2":
                return `text-[9px] leading-[13.5px] pl-[1px] ${t}`;
            case "typography-h3":
                return `text-[8px] leading-[12px] pl-[1px] pt-[2.5px] ${t}`;
            case "typography-small__t":
                return `text-[7px] leading-[10.5px] pt-[3px] font-medium ${t}`;
            case "typography-label":
                return `text-[7px] leading-[10.5px] pl-[0.5px] font-medium ${t}`;
            case "typography-button":
                return `text-[9px] leading-[13.5px] pl-[1px] pt-[1.6px] ${t}`;
            case "typography-main":
                return `text-[7.5px] leading-[11.25px] font-medium pt-[3.8px] ${t}`;
            case "typography-main_sb":
                return `text-[7.5px] leading-[11.25px] font-semibold pt-[3.8px] ${t}`;
            case "typography-small":
                return `text-[7px] leading-[10.5px] pt-[0.6px] font-medium ${t}`;
            case "packageDiscount":
                return `text-[6px] leading-[9px]  font-semibold pt-[3px] pl-[0.5px] ${t}`;
            default:
                return assertNever(t);
        }
    };
    let label = `${prefix}${dollars}`;
    if (cents && cents !== "00") {
        label += `.${cents}`;
    }
    return (React.createElement("div", { "aria-label": label, id: id, className: cn("flex", className), ...rest },
        React.createElement("span", { className: typography },
            prefix,
            dollars),
        cents && cents !== "00" && (React.createElement("span", { className: cn(centStyles(typography)) },
            ".",
            cents))));
};
export default PriceWithCents;
//# sourceMappingURL=PriceWithCents.js.map